import { Controller } from "@hotwired/stimulus"
import { Carousel } from "bootstrap"

// Connects to data-controller="carousel"
export default class extends Controller {
  static values = {
    auto: { type: Boolean, default: false },
    interval: { type: Number, default: 5000 }
  }

  connect() {
    this.carousel = Carousel.getOrCreateInstance(this.element, {
      ride: this.autoValue ? "carousel" : false,
      interval: this.autoValue ? this.intervalValue : false,
      touch: true,
      wrap: true
    })

    if (this.autoValue) {
      this.carousel.cycle()
    } else {
      this.carousel.pause()
    }
  }

  disconnect() {
    if (!this.carousel) return

    this.carousel.dispose()
    this.carousel = null
  }
}
